if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"src","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(053|187|201|69|763|886)|2([08]63|139|425)|3((08|35|47)5|[13]67|071|142|716|781|844|870)|4(097|1|234|349|382|702|845)|5(6(11|42|77)|033|091|218|324|509|546|92)|6(1(13|49|7)|2(35|42|7)|3(|67|72)|7(43|69|85)|009|540|592|628|658|943)|7((1|22|62)4|[24]89|027|465|592|78|883|930)|8(014|102|315|505|551|709|730|803|952)|9(0(49|74|9)|6(22|84|99)|35|397|485|844))$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}